import { useRef } from 'react';

import { useLegalClientBeneficiarySaveTaxResidences } from 'api/requests/onboarding/legal/beneficiary';
import { useServerErrorNotify } from 'hooks';
import { OnboardingTaxResidencyFormType } from 'modules/onboarding/common/forms/onboardingTaxResidencyForm';
import {
  getInitialData,
  getSubmitData,
} from 'modules/onboarding/common/helpers/taxResidency';
import {
  useBeforeSubmitTaxResidency,
  useOnboardingCountries,
} from 'modules/onboarding/common/hooks';

import { useOnboardingContext } from './useOnboardingContext';

export const useTaxResidency = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();
  const { countries, loading: countriesLoading } = useOnboardingCountries();

  const {
    saveTaxResidences,
    loading: submitLoading,
    error,
  } = useLegalClientBeneficiarySaveTaxResidences();

  const initialValues = useRef(
    getInitialData(data.legalClientBeneficiary.taxResidences).values
  ).current;

  const onSubmit = useBeforeSubmitTaxResidency(
    async (values: OnboardingTaxResidencyFormType) => {
      const submitData = getSubmitData(values);
      await saveTaxResidences(
        data.legalClient.id,
        data.legalClientBeneficiary.id,
        submitData
      );
      goToNext();
    }
  );

  useServerErrorNotify(error);

  return {
    onSubmit,
    goToBack,
    submitLoading,
    initialValues,
    countries,
    countriesLoading,
  };
};
